export default __webpack_public_path__ + "static/media/angbao-bonus.2cf31955.webp";